import styled from 'styled-components';

export const SingleSelectionFilterWrapper = styled.div`
  border-radius: 2px;
  white-space: nowrap;
`;

export const SingleSelectionCheckboxContainer = styled.div`
  width: 100%;
  height: 100%;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.brownishGrey};
  }
`;
